import React from "react";

import styles from "./LegalContent.module.css";

// Content is the HTML saved by the existing authenticated MDM rich-text editor.
const LegalContent = ({ html }: { html: string }) => (
  <div className={styles.content} dangerouslySetInnerHTML={{ __html: html }} />
);

export default LegalContent;
